'use client'

import { HTMLProps } from 'react'
import clsx from 'classnames'
import Image from 'next/image'
import { useLocale } from 'use-intl'
import { Text } from '@/shared/ui'
import { IPostCategory } from '@/interfaces/analytics'
import { Tag } from '@/shared/ui/tag'
import { IImage } from '@/interfaces/common'
import { getDateLabel } from '@/shared/utils'
import style from './sticky-mini-card.module.scss'

type StickyMiniCardProps = HTMLProps<HTMLDivElement> & {
  img: IImage | null
  title: string
  category: IPostCategory
  date?: string
}

export const StickyMiniCard = (props: StickyMiniCardProps) => {
  const { img, title, category, date, className, ...restProps } = props
  const currentLocale = useLocale()

  return (
    <div className={clsx(style.container, className)} {...restProps}>
      {img?.url && (
        <div className={style.img}>
          <Image src={img.url} fill alt={title} style={{ objectFit: 'cover', objectPosition: 'center top' }} />
        </div>
      )}
      <Text className={style.title} color="dark" type="d">
        {title}
      </Text>
      {date && (
        <Text className={style.date} color="dark-040" type="d">
          {getDateLabel({ date, locale: currentLocale })}
        </Text>
      )}
      <Tag color={category.color}>{category.name}</Tag>
    </div>
  )
}
